import { mdiCalendarLock, mdiCheckDecagram, mdiFire, mdiStarFourPoints } from '@mdi/js'

import type { ReviewQueueTag } from '@/types/professional-documents.types'

/**
 * Subconjunto das cores do `LabelBadge` (o tipo de lá vive no `.vue`, que o `tsc` puro não lê);
 * continua atribuível a `LabelBadgeColor` por ser união literal.
 */
export type ReviewTagColor = 'blue' | 'orange' | 'red' | 'green'

/** Tags da fila (D23 + "Bloqueia alocação"). */
export const REVIEW_TAG_CONFIG: Record<
  ReviewQueueTag,
  { label: string; color: ReviewTagColor; icon: string }
> = {
  NEW: { label: 'Novo', color: 'blue', icon: mdiStarFourPoints },
  URGENT: { label: 'Urgente', color: 'orange', icon: mdiFire },
  BLOCKS_ALLOCATION: { label: 'Bloqueia alocação', color: 'red', icon: mdiCalendarLock },
  CONCLUDED: { label: 'Concluído', color: 'green', icon: mdiCheckDecagram }
}

export const REVIEW_TAG_ORDER: ReviewQueueTag[] = [
  'NEW',
  'URGENT',
  'BLOCKS_ALLOCATION',
  'CONCLUDED'
]

export const REVIEW_TAG_OPTIONS = REVIEW_TAG_ORDER.map((tag) => ({
  title: REVIEW_TAG_CONFIG[tag].label,
  value: tag
}))

export const QUEUE_LOAD_ERROR = 'Não foi possível carregar a fila de documentos'
export const DETAIL_LOAD_ERROR = 'Não foi possível carregar os documentos do médico'
export const KANBAN_LOAD_ERROR = 'Não foi possível carregar as demandas urgentes'
export const APPROVE_ERROR = 'Não foi possível aprovar o documento'
export const REJECT_ERROR = 'Não foi possível reprovar o documento'
export const UNDO_ERROR = 'Não foi possível desfazer a decisão'
export const MOVE_ERROR = 'Não foi possível mover a demanda'
